var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRulesOffline = function SvgRulesOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 135"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rules-offline_svg__cls-2{fill:#f04336}.rules-offline_svg__cls-7{fill:#e5e5e5}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "rules-offline_svg__\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60.2 31.31-2.64 28.83s3.14 2.75 18.93-1.64c12.34-3.44 32.34-6 40.49-7a1 1 0 0 0 .28-1.9l-12.93-4.77 20.23-4.1a1 1 0 0 0-.14-2Z",
    className: "rules-offline_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m58.12 31.34-.56 28.8L58 60l-.43.19c1.34 1 4.2.85 4.2.85.52-1.71 5.07-3.62 6.9-4.88a4.51 4.51 0 0 0 1.82-4l-1.13-19.7Z",
    style: {
      fill: "#d72027"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.51 50.3.05 9.84s.22-.86 3.25-2.11 8.07-2.67 7.8-5c-.29-2.61-11.1-2.73-11.1-2.73",
    style: {
      fill: "#620e0f"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 13.46S62 17.69 65.26 23.85L68.61 53s-4.18-4-15 2.22C43.68 60.89 36 62 36 62Z",
    className: "rules-offline_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m40.46 102.42-.28-90.69A2.24 2.24 0 0 0 38 9.5a2.23 2.23 0 0 0-2.24 2.24l.07 90.62a25 25 0 0 0 2.66.14c.65 0 1.32-.03 1.97-.08",
    style: {
      fill: "#ddd6ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.46 102.42-.28-90.69A2.24 2.24 0 0 0 38 9.5h-.1l.22 93h.37c.65 0 1.32-.03 1.97-.08",
    style: {
      fill: "#ddd6ce",
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.77 96.38c-3.63.4-6.27 1.59-6.27 3s2.64 2.59 6.28 3ZM40.44 96.32v6.1c4-.32 6.92-1.56 6.92-3s-2.95-2.78-6.92-3.1",
    className: "rules-offline_svg__cls-7"
  })))));
};
export default SvgRulesOffline;